module.exports = __webpack_public_path__ + "static/media/vo.86d36e4a.jpg";